import { fetchApi } from "../utils/fetchApi";

export function fetchPrice({ filter = {}, options = {} }) {  
  return fetchApi({ url: 'price', filter, options });
}

